export default "/images/vendor/flag-icons/flags/4x3/gp.svg?ca0b8d6f4d7528c9d34dbfcc836600b1";